import { SvgIcon } from '@mui/material'

// Types
import type { SvgIconProps } from '@mui/material'

const WebSupportIconAtom = (props: SvgIconProps) => {
	return (
		<SvgIcon {...props} viewBox="0 0 51 51" fill="none">
			<path
				fill="none"
				stroke="currentColor"
				strokeWidth={3}
				strokeLinecap="round"
				strokeLinejoin="round"
				d="M25.5 46.75C37.236 46.75 46.75 37.236 46.75 25.5C46.75 13.7639 37.236 4.25 25.5 4.25C13.7639 4.25 4.25 13.7639 4.25 25.5C4.25 37.236 13.7639 46.75 25.5 46.75Z"
			/>

			<g opacity={0.4}>
				<path
					fill="none"
					stroke="currentColor"
					strokeWidth={3}
					strokeLinecap="round"
					strokeLinejoin="round"
					d="M16.9992 6.375H19.1242C14.9804 18.785 14.9804 32.215 19.1242 44.625H16.9992"
				/>

				<path
					fill="none"
					stroke="currentColor"
					strokeWidth={3}
					strokeLinecap="round"
					strokeLinejoin="round"
					d="M31.875 6.375C36.0188 18.785 36.0188 32.215 31.875 44.625"
				/>
				<path
					fill="none"
					stroke="currentColor"
					strokeWidth={3}
					strokeLinecap="round"
					strokeLinejoin="round"
					d="M6.375 34V31.875C18.785 36.0188 32.215 36.0188 44.625 31.875V34"
				/>
				<path
					fill="none"
					stroke="currentColor"
					strokeWidth={3}
					strokeLinecap="round"
					strokeLinejoin="round"
					d="M6.375 19.1251C18.785 14.9814 32.215 14.9814 44.625 19.1251"
				/>
			</g>
		</SvgIcon>
	)
}

export default WebSupportIconAtom
